module.exports = __webpack_public_path__ + "static/cooke-4658c085bbfd0206e68d89fee325af32.png";